<template>
  <div class="tags-editor">
    <label for="oldTags">Replace</label>
    <TagsInput id="oldTags" v-model="oldTags" :noCreation="true" :limit="1" :displayCount="true"></TagsInput>
    <label for="newTags">with</label>
    <TagsInput id="oldTags" v-model="newTags" :limit="1"></TagsInput>
    <Button class="replace" @click.prevent="doAction">replace</Button>
    <span class="errorMsg">{{ errorMsg }}</span>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Button from '@/components/common/Button'
import TagsInput from '@/components/common/TagsInput'

@Component({
  name: 'TagsEditor',
  components: {
    Button,
    TagsInput
  }
})
class TagsEditor extends Vue {
  errorMsg = ''

  oldTags = []
  newTags = []

  doAction() {
    if (this.newTags[0]) {
      this.doReplace()
    } else {
      this.doDelete()
    }
  }

  doReplace() {
    let oldName = this.oldTags[0]
    let newName = this.newTags[0]
    this.$fetch.put(`/bookmarks/tags/${oldName}/${newName}`).then(
      (data) => {
        this.errorMsg = `renamed ${oldName}(${data.count}) -> ${newName}`
        this.oldTags = []
        this.newTags = []
        // on recharge pour avoir le nouveau tag et le bon count
        // this.load()
      },
      (err) => {
        console.log('ko', err)
        this.errorMsg = err.cause
      }
    )
  }

  doDelete() {
    let oldName = this.oldTags[0]
    this.$fetch.delete(`/bookmarks/tags/${oldName}`).then(
      (data) => {
        this.errorMsg = `deleted ${oldName}(${data.count})`
        this.oldTags = []
        this.newTags = []
        // on recharge pour avoir le bon count
        // this.load()
      },
      (err) => {
        console.log('ko', err)
        this.errorMsg = err.cause
      }
    )
  }

}

export default TagsEditor
</script>

<style scoped lang="less">
.tags-editor {
  display: flex;
  flex-direction: row;
}
</style>
